import api from '@cannect/services/api'
import { TResponseStandard } from '@cannect/services/types'
import {
  PROGRESSIVE_ORIGIN_CHECKOUT,
  TCartPreviewItem,
  TCartPreviewResponse,
  TProductRelatedResponse,
  TProductTiersResponse
} from './types'

export const getProductTiers = async (productId: number) => {
  return api
    .get<TResponseStandard<TProductTiersResponse, 'data'>>(`/progressive-discounts/product/${productId}`)
    .then(({ data }) => data)
}

export const getCartPreview = async (items: TCartPreviewItem[]) => {
  return api
    .post<TResponseStandard<TCartPreviewResponse, 'data'>>('/progressive-discounts/cart/preview', {
      origin_checkout: PROGRESSIVE_ORIGIN_CHECKOUT,
      items
    })
    .then(({ data }) => data)
}

export const getProductRelated = async (
  productId: number,
  limit?: number,
  cartProductIds?: number[],
  benefit?: 'shipping'
) =>
  api
    .get<TResponseStandard<TProductRelatedResponse, 'data'>>(`/progressive-discounts/product/${productId}/related`, {
      params: {
        ...(limit ? { limit } : {}),
        // 'shipping' = produtos da regra de FRETE; sem o param = regra de ITEM
        ...(benefit ? { benefit } : {}),
        // IDs dos produtos do grupo já no carrinho — backend filtra pra só trazer outras variações da mesma família
        ...(cartProductIds?.length ? { cart_product_ids: cartProductIds.join(',') } : {})
      }
    })
    .then(({ data }) => data)
